import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getResourcesTitlesAndTypes = async (foiList = [], apiToken = null) => {
    if (!foiList) {
        console.log("no foiList");
        return null;
    }
    if (foiList.length === 0) {
        console.log("empty foiList");
        return null;
    }
    console.log("CALLING SERVER with getResourcestitlesandtypes")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getResourcestitlesandtypes',
            'apiToken': apiToken,
            'resourceids': foiList
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getResourcestitlesandtypes call");
    }).catch((error) => { console.log(error); });
}

export default getResourcesTitlesAndTypes;